// primaryNavData — F9.6 WAVE 2F · Horizontal primary nav specification.
//
// Reuses MENU_GROUPS from AdminMegaDropdown (menuGroups.js) — zero data
// duplication. This file only describes which top-level nav entries appear
// in the horizontal top-bar and whether each entry opens a mega-menu or
// jumps directly to a route.
//
// Shape:
//   { key, labelKey, kind: "mega" | "link", groupKey?, to?, icon?, adminOnly? }
//
// kind="mega"   → opens a dropdown panel showing MENU_GROUPS[groupKey].items
// kind="link"   → navigates straight to `to` (no dropdown)
import { MENU_GROUPS } from "../UserWidget/menuGroups";

// Hotfix header-to-sidebar · creator + partnership rimossi (gruppi non più in MENU_GROUPS).
// Aggiunto community. Nota: PrimaryNavV3 non è più montato nella dashboard (Header.jsx)
// perché i gruppi sono stati spostati nella sidebar sinistra. Questo file resta per compat
// (potenziale rollback / uso in pagine pubbliche).
export const PRIMARY_NAV_ITEMS = [
    { key: "workspace",   labelKey: "admin_menu.group.workspace",   kind: "mega", groupKey: "workspace",   responsive: "always" },
    { key: "ai-suite",    labelKey: "admin_menu.group.ai_suite",    kind: "mega", groupKey: "ai_suite",    responsive: "desktop" },
    { key: "blog",        labelKey: "admin_menu.item.blog",         kind: "link", to: "/blog",             responsive: "desktop" },
    { key: "pricing",     labelKey: "admin_menu.item.pricing",      kind: "link", to: "/app/subscription", responsive: "desktop" },
    { key: "community",   labelKey: "admin_menu.group.community",   kind: "mega", groupKey: "community",   responsive: "always" },
    { key: "admin",       labelKey: "admin_menu.group.admin",       kind: "mega", groupKey: "admin",       responsive: "always", adminOnly: true },
];

// Helper: given a groupKey, return the items array from MENU_GROUPS.
export function getGroupItems(groupKey) {
    const g = MENU_GROUPS.find((x) => x.key === groupKey);
    return g ? g.items : [];
}
